<template>
  <div>
    <div class="mb-4">
      <b-row>
        <b-col>
          <div v-if="carregandoPreview" class="d-flex align-items-center">
            <b-spinner small class="mr-2" />
            <span>{{ $t('CONTABIL.CARREGANDO_PREVIEW') }}</span>
          </div>
          <div v-else-if="!previewCarregado && !validarDadosParaPreview()" class="text-muted">
            {{ $t('CONTABIL.PREENCHA_DADOS_PARA_PREVIEW') }}
          </div>
        </b-col>
        <b-col v-if="previewCarregado" class="text-right">
          <b-badge 
            :variant="lancamentosBalanceados ? 'success' : 'warning'"
            class="p-2"
          >
            {{ lancamentosBalanceados ? $t('CONTABIL.LANCAMENTOS_BALANCEADOS') : $t('CONTABIL.LANCAMENTOS_DESBALANCEADOS') }}
          </b-badge>
        </b-col>
      </b-row>
    </div>

    <div v-if="previewCarregado">
      <h4>{{ $t('CONTABIL.PREVIEW_LANCAMENTOS_CONTABEIS') }}</h4>
      <tabela-documento
        ref="tabelaPreview"
        :items="lancamentosPreview"
        :keyAtualizatabela="keyAtualizatabela"
        @removerDocumentoItem="removerDocumentoItem"
        @editarDocumentoItem="abrirModalEditarItem"
        :editavel="true"
      />
      <b-row class="mt-3">
        <b-col>
          <b><h5>Total Crédito: {{ formatarValor(totalCreditoPreview) }}</h5></b>
        </b-col>
        <b-col>
          <b><h5>Total Débito: {{ formatarValor(totalDebitoPreview) }}</h5></b>
        </b-col>
      </b-row>
    </div>

    <div v-else>
      <div class="mb-4">
        <dados-documento
          :form="formulario"
          :valor="maiorSoma"
          @refs="capturarRefs"
        />
      </div>

      <div>
        <h4>{{ $t('CONTABIL.LISTA_LANCAMENTOS_VINCULADOS') }}</h4>
        <dados-documento-item
          ref="documentoItem"
          :form="formularioDocumentoItem"
          :resetarValidacao="resetarValidacao"
          @adicionarDocumentoItem="adicionarDocumentoItem"
        />
        <tabela-documento
          ref="tabelaDocumento"
          :items="formulario.itens"
          :keyAtualizatabela="keyAtualizatabela"
          @removerDocumentoItem="removerDocumentoItem"
          @editarDocumentoItem="abrirModalEditarItem"
        />
        <b-row class="mt-3">
          <b-col>
            <b><h5>Total Crédito: {{ formatarValor(creditoTotal) }}</h5></b>
          </b-col>
          <b-col>
            <b><h5>Total Débito: {{ formatarValor(debitoTotal) }}</h5></b>
          </b-col>
        </b-row>
      </div>
    </div>

    <modal-editar-documento-item
      v-show="itemSelecionado"
      ref="modalEditarDocumentoItem"
      :item="itemSelecionado"
      @atualizar-item="atualizarItemNaTabela"
    />
  </div>
</template>

<script>
import DadosDocumento from '@/views/contabil/lancamentos/components/modal/Dados.vue';
import TabelaDocumento from '@/views/contabil/lancamentos/components/modal/Tabela.vue';
import DadosDocumentoItem from '@/views/contabil/lancamentos/components/modal/DadosDocumentoItem.vue';
import ModalEditarDocumentoItem from '@/views/contabil/lancamentos/components/modal/ModalEditarDocumentoItem.vue';
import helpers from '@/common/utils/helpers';
import NotaFiscalService from '@/common/services/nota-fiscal/nota-fiscal.service';

export default {
  name: 'LancamentosContabeis',
  props: {
    form: { type: Object, default: () => ({}) },
  },
  components: {
    DadosDocumento,
    TabelaDocumento,
    DadosDocumentoItem,
    ModalEditarDocumentoItem,
  },
  data() {
    return {
      keyAtualizatabela: 1,
      resetarValidacao: false,
      carregandoPreview: false,
      previewCarregado: false,
      lancamentosPreview: [],
      totalCreditoPreview: 0,
      totalDebitoPreview: 0,
      lancamentosBalanceados: false,
      formulario: { 
        itens: [],
        categoriaId: null,
        dataMovimento: null
      },
      formularioDocumentoItem: {
        descricao: '',
        planoConta: '',
        valor: '',
        tipoMovimento: '',
      },
      itemSelecionado: null,
      refs: [],
    };
  },
  computed: {
    maiorSoma() {
      let creditoTotal = 0;
      let debitoTotal = 0;
      this.formulario.itens.forEach((movimento) => {
        if (movimento.tipoMovimentoDescricao === 'Crédito') {
          creditoTotal += movimento.valor;
        } else if (movimento.tipoMovimentoDescricao === 'Débito') {
          debitoTotal += movimento.valor;
        }
      });
      return Math.max(creditoTotal, debitoTotal);
    },
    creditoTotal() {
      return this.formulario.itens.reduce((total, item) => {
        return item.tipoMovimentoDescricao === 'Crédito'
          ? total + item.valor
          : total;
      }, 0);
    },
    debitoTotal() {
      return this.formulario.itens.reduce((total, item) => {
        return item.tipoMovimentoDescricao === 'Débito'
          ? total + item.valor
          : total;
      }, 0);
    },
  },
  mounted() {
    console.log('=== LANCAMENTOS CONTABEIS MOUNTED ===');
    console.log('Form recebido:', this.form);
    this.inicializarDadosMockados();
    this.$nextTick(() => {
      console.log('NextTick - tentando carregar preview');
      this.tentarCarregarPreviewAutomaticamente();
    });
  },
  
  activated() {
    this.$nextTick(() => {
      this.tentarCarregarPreviewAutomaticamente();
    });
  },
  watch: {
    form: {
      handler() {
        this.$nextTick(() => {
          this.tentarCarregarPreviewAutomaticamente();
        });
      },
      deep: true,
      immediate: true
    },
    'form.notasFiscaisItens': {
      handler() {
        if (this.previewCarregado) {
          this.tentarCarregarPreviewAutomaticamente();
        } else {
          this.tentarCarregarPreviewAutomaticamente();
        }
      },
      deep: true
    },
    'form.notasFiscaisParcelas': {
      handler() {
        if (this.previewCarregado) {
          this.tentarCarregarPreviewAutomaticamente();
        } else {
          this.tentarCarregarPreviewAutomaticamente();
        }
      },
      deep: true
    },
    'form.impostos': {
      handler() {
        if (this.previewCarregado) {
          this.tentarCarregarPreviewAutomaticamente();
        } else {
          this.tentarCarregarPreviewAutomaticamente();
        }
      },
      deep: true
    },
    'form.historicoLancamento': {
      handler() {
        if (this.previewCarregado) {
          this.tentarCarregarPreviewAutomaticamente();
        } else {
          this.tentarCarregarPreviewAutomaticamente();
        }
      },
      deep: true
    }
  },
  methods: {
    async tentarCarregarPreviewAutomaticamente() {
      if (this.validarDadosParaPreview() && !this.carregandoPreview) {
        await this.carregarPreviewLancamentos();
      } 
    },
    
    async carregarPreviewLancamentos() {
      if (!this.validarDadosParaPreview()) {
        return console.log('❌ Dados inválidos para preview');
      }

      this.carregandoPreview = true;
      
      try {
        const requestData = this.prepararDadosParaPreview();
        const response = await NotaFiscalService.previewLancamentosContabeis(requestData);
      
        if (response && response.success && response.data) {
          this.lancamentosPreview = response.data.lancamentos.map(lancamento => ({
            id: lancamento.id,
            tipoMovimentoDescricao: lancamento.tipoMovimentoDescricao,
            valor: lancamento.valor,
            contaContabilCompleto: lancamento.contaContabilCompleto || `${lancamento.planoContaDescricao || 'Conta não encontrada'}`,
            descricao: lancamento.descricao,
            planoContaId: lancamento.planoContaId,
            tipoMovimento: lancamento.tipoMovimento === 'Credito' ? 2 : 1,
            origem: lancamento.origem
          }));
          
          this.totalCreditoPreview = response.data.totalCredito;
          this.totalDebitoPreview = response.data.totalDebito;
          this.lancamentosBalanceados = response.data.lancamentosBalanceados;
        } else {
          console.warn('Resposta do preview não contém dados válidos:', response);
        }
        this.previewCarregado = true;
        this.keyAtualizatabela++;
        
      } catch (error) {
        console.error('Erro ao carregar preview:', error);
      } finally {
        this.carregandoPreview = false;
      }
    },
    
    validarDadosParaPreview() {
      const temItens = this.form.notasFiscaisItens && this.form.notasFiscaisItens.length > 0;
      const temParcelas = this.form.notasFiscaisParcelas && this.form.notasFiscaisParcelas.length > 0;
      
      const tipoNotaFiscal = this.form.tipoNotaFiscal;
      let resultado;
      
      if (tipoNotaFiscal === 320) { 
        resultado = temParcelas;
      } else { 
        resultado = temItens && temParcelas;
      }
      
      return resultado;
    },
    
    prepararDadosParaPreview() {
      let parcelas = this.form.notasFiscaisParcelas || [];
      
      if (this.form.historicoLancamento && this.form.historicoLancamento.value) {
        parcelas = parcelas.map(parcela => ({
          ...parcela,
          historicoLancamentoId: this.form.historicoLancamento.value
        }));
      }
      
      return {
        notasFiscaisItens: this.form.notasFiscaisItens || [],
        notasFiscaisParcelas: parcelas,
        impostos: this.form.impostos || [],
        tipoNotaFiscal: this.form.tipoNotaFiscal,
        tipoCompra: this.form.tipoCompra
      };
    },
    
    inicializarDadosMockados() {
      this.formulario = {
        itens: [],
        categoriaId: null,
        dataMovimento: null
      };
    },
    formatarValor(valor) {
      return valor ? helpers.formatacaoMoedaBRL(valor) : '';
    },
    capturarRefs(refs) {
      this.refs = refs;
    },
    abrirModalEditarItem(item) {
      this.itemSelecionado = item;
      this.$nextTick(() => {
        if (this.$refs.modalEditarDocumentoItem) {
          this.$refs.modalEditarDocumentoItem.abrir();
        } 
      });
    },
    atualizarItemNaTabela(itemAtualizado) {
      if (this.previewCarregado) {
        const index = this.lancamentosPreview.findIndex(
          (item) => item === this.itemSelecionado
        );
        if (index !== -1) {
          const itemCorrigido = {
            ...this.lancamentosPreview[index],
            ...itemAtualizado,
            valor: Number(itemAtualizado.valor),
          };
          this.$set(this.lancamentosPreview, index, itemCorrigido);
          this.recalcularTotaisPreview();
          this.keyAtualizatabela++;
          this.itemSelecionado = null;
        }
      } else {
        const index = this.formulario.itens.findIndex(
          (item) => item === this.itemSelecionado
        );
        if (index !== -1) {
          const itemCorrigido = {
            ...this.formulario.itens[index],
            ...itemAtualizado,
            valor: Number(itemAtualizado.valor),
          };
          this.$set(this.formulario.itens, index, itemCorrigido);
          this.keyAtualizatabela++;
          this.itemSelecionado = null;
        }
      }
    },
    
    recalcularTotaisPreview() {
      this.totalCreditoPreview = this.lancamentosPreview
        .filter(item => item.tipoMovimentoDescricao === 'Crédito')
        .reduce((total, item) => total + item.valor, 0);
        
      this.totalDebitoPreview = this.lancamentosPreview
        .filter(item => item.tipoMovimentoDescricao === 'Débito')
        .reduce((total, item) => total + item.valor, 0);
        
      this.lancamentosBalanceados = Math.abs(this.totalCreditoPreview - this.totalDebitoPreview) < 0.01;
    },
    adicionarDocumentoItem() {
      const novoItem = {
        id: Date.now(), 
        tipoMovimentoDescricao: this.formularioDocumentoItem.tipoMovimento?.descricao || '',
        valor: Number(this.formularioDocumentoItem.valor),
        contaContabilCompleto: this.formularioDocumentoItem.planoConta?.text || '',
        descricao: this.formularioDocumentoItem.descricao,
        planoContaId: this.formularioDocumentoItem.planoConta?.id,
        tipoMovimento: this.formularioDocumentoItem.tipoMovimento?.id
      };
      
      this.formulario.itens.push(novoItem);
      this.keyAtualizatabela++;
      
      this.formularioDocumentoItem = {
        descricao: '',
        planoConta: '',
        valor: '',
        tipoMovimento: '',
      };
      
      this.resetarValidacao = !this.resetarValidacao;
    },
    removerDocumentoItem(item) {
      if (this.previewCarregado) {
        const index = this.lancamentosPreview.findIndex(
          (lancamento) => lancamento.id === item.item.id
        );
        if (index !== -1) {
          this.lancamentosPreview.splice(index, 1);
          this.recalcularTotaisPreview();
          this.keyAtualizatabela++;
        }
      } else {
        const index = this.formulario.itens.findIndex(
          (lancamento) => lancamento.id === item.item.id
        );
        if (index !== -1) {
          this.formulario.itens.splice(index, 1);
          this.keyAtualizatabela++;
        }
      }
    },
    
    obterLancamentosEditados() {
      if (this.previewCarregado) {
        return this.lancamentosPreview;
      }
      return this.formulario.itens;
    },
    
    temLancamentosEditados() {
      return this.previewCarregado ? this.lancamentosPreview.length > 0 : this.formulario.itens.length > 0;
    },
    
    onTabActivated() {
      console.log('=== ON TAB ACTIVATED ===');
      this.$nextTick(() => {
        console.log('OnTabActivated - tentando carregar preview');
        this.tentarCarregarPreviewAutomaticamente();
      });
    }
  },
};
</script>

<style scoped>
.linha-credito {
  background-color: rgba(67, 230, 67, 0.199);
}
.linha-debito {
  background-color: rgba(241, 109, 109, 0.336);
}
</style>